export default {
  tableData: [
    {
      name: '',
      matches: 0,
      points: 0,
      won: 0,
      lost: 0,
      draw: 0,
      goals: 0,
      opponentGoals: 0,
      goalDifference: 0,
    },
  ],
  latestMatch: {
    home: '',
    guest: '',
    goalsHome: 0,
    goalsGuest: 0,
    date: '',
  },
};



// WEBPACK FOOTER //
// ./src/store/state.js